import Vue from 'vue'
import * as Config from "../config";
import Cookies from "js-cookie";
import Vuex from 'vuex'
import axios from 'axios'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    me: [],
    id_room_user: null,
  },
  mutations: {
    LOGIN(state, data) {
      state.me = data.data;
      Cookies.set("access_token", data.data.access_token.token);
    },
    LOGOUT_OK(state) {
      Cookies.remove("access_token");
      Cookies.remove("user_name");
      Cookies.remove("picture");
      state.me = [];
      Cookies.remove("id")
    },
    CHATROOM(state, data) {
      state.id_room_user = data
    }
  },
  actions: {
    login({ commit }, form) {
      console.log(form)
      //commit("LOGIN");

      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/auth/login", form)
          .then(response => {
            if (response.data.code === 200) {
              const accessToken = response.data.data.access_token.token;
              const username = response.data.data.full_name;
              const profile = response.data.data.profile_picture;

              const id = response.data.data.id;

              Cookies.set("access_token", accessToken, { expires: 1 });
              Cookies.set("user_name", username)
              Cookies.set("picture", profile)
              Cookies.set("id", id)
              commit("LOGIN", response.data);
              resolve(response.data);
            } else {
              commit("LOGIN_FAIL1");
              console.log(response);
              reject(response.data);
            }
          })
          .catch(error => {
            console.log("LOGIN_FAIL");
            console.log(error);

            console.log(error.response.data.data);
            reject(error);
          });
      });
    },
    logout({ commit }) {
      commit("LOGOUT_OK");
    },

    adminCounters({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_account/admin/dashboard")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //USERS
    GetUser({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user/" + form.id)
          .then(response => {

            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    UserAll({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user/all?index=role_id&value=3&orderby=id&key=desc")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },


    InvestPublicAll({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/placement/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    RegisterUser({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/user/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    RegisterUserbyAdmin({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/user/manually/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    RegisterImageInvestP({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/placement/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdateImageInvestP({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/placement/update/"+form.get("id"), form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },


    createData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form.data)
      return new Promise((resolve, reject) => {
        axios.post(Config.apiPath + "/" + form.url, form.data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },


    UserUpdate({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/user/update/" + form.id, form.params)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    changeactivateUser({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath + "/user/change_status/" + form.user_id + "/" + form.status + "")
          .then(response => {
            resolve(response.data);
            console.log(response.data)
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath + "/" + form.url, { params: form.params })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    // Earn and lost history
    changeStatusData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath + "/" + form.url + "/" + form.id + "/" + form.status)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getAllEarnLost({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/earn_lost_history/all?order_key=id&order_value=desc")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    ChangeEarnLostStatus({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath + "/earn_lost_history/change_status/" + form.id + "/" + form.status + "")
          .then(response => {
            resolve(response.data);
            console.log(response.data)
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    // Account Transactions

    getAllInvest({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/account_transaction/all?index=type_transaction_id&value=1&orderby=id&key=desc")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAllWD({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/account_transaction/all?index=type_transaction_id&value=5&orderby=id&key=desc")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getWithdrawRequest({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/account_transaction/all?index=type_transaction_id&value=8&orderby=id&key=desc")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getTransactionById({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/account_transaction/" + id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    changePayStatus({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/account_transaction/change_payment_status/" + form.id + "/" + form.status)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    changeTransactionStatus({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/account_transaction/change_status/" + form.id + "/" + form.status)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    StoreAny({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/account_transaction/any/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    StoreUserAccount({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/user_account/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    StoreByPercent({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/account_transaction/earn_lose/percentage/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Bank accounts

    GetBanksByUser({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_bank/all?index=user_id&value=" + form.id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          })
      })
    },

    // Accounts

    GetAccountsByUser({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_account/user/" + form.id + "/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          })
      })
    },

    GetAccountTransactions({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/account_transaction/account/" + form.id + "/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          })
      })
    },

    GetAccountBalance({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_account/get_balance/" + form.id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          })
      })
    },

    // COMPANY BANK

    getCompanyBank({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/company_bank/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // chat
    loadChat_Messages({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/room/msg/all?active=1&index=room_id&value=" + form.room + "&orderby=id&key=desc")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          })
      })
    },

    new_Message({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/room/msg/save", form)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    delete_Chat_Message({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/room/msg/change_status/" + form.id + "/" + form.status)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Payment reports
    GetPaymentReports({ commit, dispatch }, type_id) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/payment_report/all?type_transaction_id=" + type_id + "")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          })
      })
    },

    GetPaymentReportsByUser({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/payment_report/user/" + form.id + "/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          })
      })
    },

    StorePayment({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/payment_report/withdraw/save", form)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    //   Notifications

    getAllNotifications({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/notification/user/" + form.id + "/all?index=readed&value=0")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          })
      })
    },

    changeStatusNotif({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/notification/change_status/" + form.id + "/" + form.status)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    changeAllNotif({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/notification/change_all_status/" + form.status)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Audit logs

    GetAuditLogsByUser({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_audit/all?index=user_id&value=" + form.id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          })
      })
    },

    AllCountry() {

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/country/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    AllStates() {

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/states/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },


  },
  modules: {
  }
})
